<template>
    <div>
        <b-modal
            ref="modalEdit"
            hide-footer
            :title="titleModal"
            size="md"
            no-close-on-backdrop
            hide-header-close
            hide-header
        >
            <div class="title-modal">
                <div class="title-text-modal">{{ titleModal }}</div>
                <div
                    class="float-right btn-hover-modal"
                    @click="closeModal(true)"
                >
                    <xIcon/>
                </div>
            </div>
            <div class="modal-edicao d-block mb-3 modal-edicao-label mt-6">
                <b-row>
                    <b-col cols="12" class="d-block text-parcela">
                        <span class="label-conta">Tipo de Conta</span>
                        <b-form-input
                            name="tipo_conta"
                            class="modal-edicao-input"
                            type="text"
                            v-model="accountClassSelected.description"
                            autocomplete="off"
                            placeholder="Digite o nome do tipo da conta"
                            v-validate="'required|maxLength:50'"
                            :state="validateState('tipo_conta')"
                        />
                    </b-col>
                </b-row>
                <b-row class="filters-orientation">
                    <b-col class="d-block text-parcela">
                        <span class="label-conta">Fechamento Mensal <InfoIcon size="16" class="mb-1" v-b-tooltip.hover title="O fechamento mensal se refere a uma conta que tem um dia específico de fechamento antes do dia de pagamento" /></span>
                        <ToggleSwitch
                            name="tipo-conta-close-monthly"
                            class="toggle-tipo-conta"
                            :value="accountClassSelected.closeMonthly"
                            @toggle="_ => changeToggle(accountClassSelected.closeMonthly, 'closeMonthly')"
                        />
                    </b-col>
                    <b-col class="d-block text-parcela">
                        <span class="label-conta">Pago Automatico <InfoIcon size="16" class="mb-1" v-b-tooltip.hover title="Se refere a uma conta cujos lançamentos envolvem uma saída imediata, mas não uma conta a pagar" /></span>
                        <ToggleSwitch
                            name="tipo-conta-pago-automatico"
                            class="toggle-tipo-conta"
                            :value="accountClassSelected.automaticPay"
                            @toggle="_ => changeToggle(accountClassSelected.automaticPay, 'automaticPay')"
                        />
                    </b-col>
                </b-row>
            </div>
            <b-button class="ml-1 mt-3 float-left btn-modal btn-cancel" @click="closeModal(true)">Cancelar</b-button>
            <b-button class="mt-3 float-left btn-modal btn-limpar" @click="cleanModal()">Limpar</b-button>
            <b-button
                class="mt-3 ml-1 float-right btn-modal btn-salvar"
                @click="saveRecord"
                :disabled="invalidForm || saving"
            >
                Salvar
            </b-button>
        </b-modal>
    </div>
</template>

<script>
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { AccountClassService } from "@/services/accountClass";
	import emitter from "@/eventBus.js";
	import ToggleSwitch from "@/components/ToggleSwitch";
	import { mapState } from "vuex";

	export default {
		components: {
			ToggleSwitch
		},

		props: {
			accountClassData: {
				type: Object,
				required: false
			},
			name: {
				type: String,
				required: false
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				titleModal: "",
				accountClassSelected: {
					idAccountClass: null,
					description: "",
					closeMonthly: false,
					automaticPay: false
				},
				accountClassService: new AccountClassService(),
				loading: true,
				noEditAccountClass: false,
				invalidForm: true,
				saving: false,
				accountClassOptions: [],
				accountClassFull: []
			};
		},

		computed: mapState(["accountClass"]),

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			this.showAccountClass();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			showAccountClass () {
				this.invalidForm = true;
				const {
					idAccountClass = null,
					description = "",
					closeMonthly = false,
					automaticPay = false
				} = this.accountClassData;

				if (!idAccountClass) {
					this.accountClassSelected.description = this.name;
					this.titleModal = "Cadastrar Novo Tipo de Contas";
					this.noEditAccount = true;
				} else {
					this.accountClassSelected.description = description;
					this.titleModal = "Editar Tipo de Contas";
					this.noEditAccount = false;
				}

				this.accountClassSelected.idAccountClass = idAccountClass;
				this.accountClassSelected.closeMonthly = closeMonthly;
				this.accountClassSelected.automaticPay = automaticPay;
				this.$refs.modalEdit.show();
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			closeModal (cancelled) {
				this.$refs.modalEdit.hide();
				this.cleanModal();
				this.accountClassSelected.idAccountClass = null;
				this.saving = false;
				this.invalidForm = true;
				this.$emit("closeModal", cancelled);
			},

			cleanModal () {
				this.accountClassSelected.description = "";
				this.accountClassSelected.closeMonthly = false;
				this.accountClassSelected.automaticPay = false;
			},

			async saveRecord () {
				const invalidFields = await this.validateModal();
				if (invalidFields) {
					await this.$swal({
						title: "Formulário Inválido",
						text: "Existe informação sem preencher!",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return;
				}

				if (await this.recordExist()) {
					return;
				}

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};
				const payload = {
					description: this.accountClassSelected.description,
					closeMonthly: this.accountClassSelected.closeMonthly,
					automaticPay: this.accountClassSelected.automaticPay
				};

				if (this.accountClassSelected.idAccountClass)
					payload.idAccountClass = this.accountClassSelected.idAccountClass;

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						const newAccountClass = await this.accountClassService.upsertAccountClass({payload});

						this.$emit("findAccountClass", true);
						this.$emit("newAccountClass", newAccountClass);
						emitter.emit("reloadAccountClass", { reload: true });
						this.closeModal();

						return {
							title: "Sucesso!",
							body: "Tipo de Contas salva com sucesso.",
							config
						};
					} catch (error) {
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar tipo de contas!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			async validateModal () {
				const validationFields = Object.keys(this.veeFields);
				if (!validationFields.length)
					return true;

				const validations = validationFields.reduce((acc, ref) => {
					if (this.veeFields[ref] && this.veeFields[ref].invalid)
						return [...acc, this.veeFields[ref].invalid];

					return acc;
				}, []);

				const invalidFields = validations.filter(field => field);
				return Boolean(invalidFields && invalidFields.length);
			},

			changeToggle (status, field) {
				if (field === "closeMonthly") {
					this.accountClassSelected.closeMonthly = !status;
					if (this.accountClassSelected.closeMonthly && this.accountClassSelected.automaticPay) this.accountClassSelected.automaticPay = false;
				} else {
					this.accountClassSelected.automaticPay = !status;
					if (this.accountClassSelected.automaticPay && this.accountClassSelected.closeMonthly) this.accountClassSelected.closeMonthly = false;
				}
			},

			async recordExist () {
				const recordExist = this.accountClass.find(ac => ac.description === this.accountClassSelected.description && this.accountClassSelected.idAccountClass !== ac.idAccountClass);
				if (recordExist) {
					await this.$swal({
						title: "Registro já existe",
						text: "Não é possível criar o registro, altere o nome e tente novamente.",
						type: "error",
						showCancelButton: false,
						confirmButtonColor: "#DD6B55",
						confirmButtonText: "OK",
						reverseButtons: true
					});
					return true;
				}

				return false;
			}
		}
	};
</script>